import api, { transformMultipart, transformRequest, transformResponse } from "services/api";

export const dataImportAPI = api
  .enhanceEndpoints({
    addTagTypes: ["ImportHistory"],
  })
  .injectEndpoints({
    endpoints: (build) => ({
      fetchImportHistory: build.query({
        query: (queryParams = { type: "", types: [], statuses: [], creditorIds: [] }) => {
          const params = new URLSearchParams();
          if (queryParams.type) params.append("type", queryParams.type);
          queryParams.statuses?.forEach((status) => params.append("statuses", status));
          queryParams.types?.forEach((type) => params.append("types", type));
          queryParams.creditorIds?.forEach((id) => params.append("creditor_ids", id));
          return `/api/v1/core/data-import/?${params.toString()}`;
        },
        transformResponse: (response) => transformResponse(response),
        providesTags: (results) =>
          results
            ? [{ type: "ImportHistory", id: "LIST" }]
            : [{ type: "ImportHistory", id: "LIST" }],
      }),
      postDataImportCreate: build.mutation({
        query: (payload) => ({
          url: `/api/v1/core/data-import/create/`,
          method: "POST",
          body: transformRequest(payload),
        }),
        transformResponse: (response) => transformResponse(response),
        invalidatesTags: [{ type: "ImportHistory", id: "LIST" }],
      }),
      postMultirowDataImportCreate: build.mutation({
        query: ({ file, values }) => ({
          url: `/api/v1/core/data-import/create/`,
          method: "POST",
          body: transformMultipart(values, file),
        }),
        transformResponse: (response) => transformResponse(response),
        invalidatesTags: [{ type: "ImportHistory", id: "LIST" }],
      }),
    }),
  });

export const {
  useFetchImportHistoryQuery,
  usePostDataImportCreateMutation,
  usePostMultirowDataImportCreateMutation,
} = dataImportAPI;
